import page from "./page";
import format from "./format";
import message from "./message";
import validation from "./validation";
import object from "./object";
export const TRANSLATIONS_EN = {
    format,
    page,
    message,
    validation,
    object,
};
